export default __webpack_public_path__ + "static/media/safia.34788268.png";